export default function getVotesReducer(state={}, action) {
    switch(action.type){
        case "get_votes_suc": {
            return action.payload
        }
        default: {
            return state
        }
    }
}